import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class CoeBiddingPreparationService {
  constructor(private http: HttpUtilService) {}

  COEBiddingPreparation(payload: {
    ArrangeBy?: string;
    EndingContractNo: number;
    FromDate: string;
    Option: number;
    StartingContractNo: number;
    StartingRefNo: number;
    ToDate: string;
  }): Observable<any> {
    return this.http.post(
      "COEBiddingPreparationServices.asmx/COEBiddingPreparation",
      {
        model: payload,
      },
    );
  }
}
